import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { select } from '@angular-redux/store';
import { TranslateService } from '@ngx-translate/core';

import {
    ApplicationFacade,
    CustomerFacade,
    CustomerService,
    LoginFacade,
    NotificationFacade,
    SessionService
} from '@ridango/components';
import { AppStartupService, Language, LogService, NetworkService, OnboardingService } from '@ridango/core';
import { HeaderMenuService } from '../../../services/header-menu.service';

import { HelperService } from '../../../services/helper.service';
import { HeaderComponent } from '../header.component';
import Env from '@ridango/core/env';
import { LocaleService } from '../../../../services/locale.service';
import { AnalyticsService } from '@ridango/core/lib/services/analytics.service';

@Component({
    selector: 'gl-header-landing-template-vl',
    templateUrl: './header-landing-template-vl.component.html',
    styleUrls: ['./header-landing-template-vl.component.scss']
})
export class HeaderLandingTemplateVlComponent extends HeaderComponent implements OnInit {
    @Input() mobileMenuOpen = false;
    @Input() languages: Language[];
    @Input() selected: Language;
    @Input() loggedInCustomer: string;
    @Output() onToggleMobileMenu: EventEmitter<any> = new EventEmitter();
    @Output() onCloseMobileMenu: EventEmitter<any> = new EventEmitter();
    @Output() requestLanguageChange: EventEmitter<Language> = new EventEmitter();
    @Output() onOidcLogin: EventEmitter<void> = new EventEmitter();

    @select(['auth', 'customer', 'data']) customer$;

    constructor(
        appConfig: AppStartupService,
        applicationFacade: ApplicationFacade,
        eRef: ElementRef,
        ls: LogService,
        @Inject(DOCUMENT) document: any,
        router: Router,
        ridangoAuth: SessionService,
        notification: NotificationFacade,
        renderer: Renderer2,
        helper: HelperService,
        loginFacade: LoginFacade,
        translate: TranslateService,
        @Inject('ENV') env: Env,
        onboardingService: OnboardingService,
        customerService: CustomerService,
        customerFacade: CustomerFacade,
        networkService: NetworkService,
        localeService: LocaleService,
        headerMenuService: HeaderMenuService,
        analyticsService: AnalyticsService
    ) {
        super(
            appConfig,
            applicationFacade,
            eRef,
            ls,
            document,
            router,
            localeService,
            ridangoAuth,
            notification,
            renderer,
            helper,
            loginFacade,
            translate,
            env,
            onboardingService,
            customerService,
            customerFacade,
            networkService,
            headerMenuService,
            analyticsService
        );
    }

    ngOnInit() {
        super.ngOnInit();
    }

    toggleMobileMenu() {
        this.onToggleMobileMenu.emit();
    }

    closeMobileMenu() {
        this.onCloseMobileMenu.emit();
    }

    changeLanguage(lang) {
        this.requestLanguageChange.emit(lang);
    }
}
